import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { globalVariable } from 'src/app/globalVariable/globalvariable';
import { CommonService } from 'src/app/services/common.service';
import { saveAs } from 'file-saver';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interval } from 'rxjs';
import { PopupimmudbcontentComponent } from '../popupimmudbcontent/popupimmudbcontent.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  selectedIndexVal: any
  htmlContent: string | null = null;
  blobUrl: string | null = null;
  safeurl: any;
  constructor(private _snackBar: MatSnackBar, private router: Router, private commonServ: CommonService, private http: HttpClient, private sanitizer: DomSanitizer, private modalService: NgbModal, public dialog: MatDialog) { }

  // @ViewChild('content') popupview !: ElementRef;

  ngOnInit(): void {
    this.commonServ.callingpublickey().subscribe((val) => {
      console.log("val alert", val)
      if (val.hasOwnProperty("publicKey")) {
        const publicKeyBase64 = val['publicKey'];
        globalVariable.publickey = publicKeyBase64;
        this.getDocumentType()

      }
    })

  }
  ngOnDestroy() {
    // Clean up Blob URL when component is destroyed
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  }
  signin() {
    this.router.navigate(["/login"]);
  }

  publicDoc() {
    this.router.navigate(["/public-documents/"]);
  }



  tabList: Array<string> = []
  documentsList: Array<Object> = []

  getDocumentType() {
    this.commonServ.fetchPublicDocumentType("Inside Trust").subscribe(
      (res) => {
        console.log("res", res)
        res.forEach((element) => {
          this.tabList.push(element.lookup_code)
        })
      }, (err) => {
        console.log(err);
      }
    )
  }




}
